import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrandModelService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllBrandModels(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.BrandModel,
      queryString:`page=${page}&size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async createBrandModels(name,brandId){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.BrandModel
    },{
      modelName:name,
      brandId:brandId
    });
    return await firstValueFrom(observable);
  }

  async updateBrandModels(id,name,brandId){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.BrandModel
    },{
      id:id,
      modelName:name,
      brandId:brandId
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
